import { render, staticRenderFns } from "./Tokuteisho.vue?vue&type=template&id=4db0ed4a&scoped=true&"
import script from "./Tokuteisho.vue?vue&type=script&lang=js&"
export * from "./Tokuteisho.vue?vue&type=script&lang=js&"
import style0 from "./Tokuteisho.vue?vue&type=style&index=0&id=4db0ed4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db0ed4a",
  null
  
)

export default component.exports